import { type FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Task } from '@repo/shared';

import { useModels } from '@/api/generated';
import MultiCombobox, {
  type MultiComboboxProps,
} from '@/components/ui/multi-combobox';
import { Skeleton } from '@/components/ui/skeleton';

interface ModelsComboboxProps
  extends Omit<MultiComboboxProps<false>, 'options'> {
  task?: Task;
}
const ModelsCombobox: FC<ModelsComboboxProps> = ({ task, ...props }) => {
  const { t } = useTranslation();
  const { data: models, isLoading } = useModels({
    task,
  });

  const options = useMemo(
    () =>
      (models ?? []).map((model) => ({
        value: model.id,
        label: model.name,
      })),
    [models]
  );

  if (isLoading) {
    return <Skeleton className='h-10 w-full' />;
  }

  return (
    <MultiCombobox
      options={options}
      {...props}
      placeholder={t('components.modelCombobox.placeholder')}
    />
  );
};

export default ModelsCombobox;
